"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight } from "lucide-react";
export default function ThePathToYourself() {
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="der-weg-zu-sich-selbst" className="relative py-24 md:py-32 bg-accent/30 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="flex flex-col lg:flex-row items-center justify-between">
          
          {}
          <div ref={imageRef} className={`w-full lg:w-[45%] relative z-10 transition-all duration-1000 ease-out ${isImageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            {}
            <div className="relative max-w-xl lg:mr-auto lg:ml-8">
              <img src="https://proper-salmon-1.10web.cloud/wp-content/uploads/2026/04/IMG_9466-scaled.jpg" alt="Dr. Laura Meier - Gründerin von Wandelherz" className="w-full h-full object-cover rounded-sm shadow-2xl" />
              {}
              <div className="absolute -bottom-12 -left-12 w-48 h-48 bg-primary/10 rounded-full blur-3xl -z-10 pointer-events-none"></div>
            </div>
          </div>

          {}
          <div ref={textRef} className={`w-full lg:w-[45%] relative z-20 mt-12 lg:mt-0 lg:-ml-[5%] transition-all duration-1000 delay-300 ease-out ${isTextVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            <div className="p-8 shadow-xl border border-border/40 rounded-sm !text-[hsl(251,91%,95%)] !bg-[hsl(251,91%,95%)] md:p-12 lg:p-16">
              <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-foreground mb-6 leading-tight">Der Weg zu sich selbst und innerer Freiheit</h2>
              
              <div className="space-y-6 text-muted-foreground text-lg leading-relaxed mb-10">
                <p>Bei Wandelherz glaube ich daran, dass wahre Heilung von innen kommt. Es ist eine Reise der emotionalen Klarheit und des geerdeten spirituellen Wachstums, die Mut und einen sicheren Raum erfordert.</p>
                <p>Ich begleite Dich mit professioneller Expertise und authentischer Hingabe auf diesem Weg. Gemeinsam schaffen wir Raum für Deine innere Entwicklung – frei von esoterischen Klischees, fokussiert auf das Wesentliche und Deine individuelle Transformation.</p>
              </div>

              <Button asChild variant="outline" size="lg" className="rounded-none border-primary/20 hover:bg-primary/5 text-primary group font-medium tracking-wide">
                <Link to="/AngebotePage">Begleitung entdecken</Link>
              </Button>
            </div>
          </div>

        </div>
      </div>
    </section>;
}